import script from "./GameSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./GameSelect.vue?vue&type=script&setup=true&lang=ts"

import "./GameSelect.vue?vue&type=style&index=0&id=047d61c6&scoped=true&lang=scss"

import exportComponent from "/builds/digithia/escape-game/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047d61c6"]])

export default __exports__